import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 上报信息列表-未使用
export function batchSubmit(data) {
    return request({
        baseURL,
        url: '/emergencyReport/batchSubmit',
        method: 'post',
        data
    })
}
// 新增上报信息
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyReport/save',
        method: 'post',
        data
    })
}
//修改上报信息
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyReport/update',
        method: 'post',
        data
    })
}
//查询上报信息列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyReport/list',
        method: 'get',
        params
    })
}
//查询上报信息
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyReport/detail?id=' + id,
        method: 'get',
    })
}
//删除上报信息
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyReport/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}